import React from "react"
import { Link } from "react-router-dom"

type Props = {
    paymentId: string,
    label: string,
}

const PaymentLink = (props: Props) => {
    return <Link to={"/payments/" + props.paymentId + "/edit"}>{props.label}</Link>
}

export default PaymentLink


// WEBPACK FOOTER //
// ./src/payment/components/PaymentLink.tsx